import React, { useEffect, useState } from "react";
import './SessionTimeout.scss';
import * as api from '../../requests';
import { Spinner } from "../Loaders/Loaders";
import Cookies from 'js-cookie';

export default function SessionTimeout() {
    const [fullAuthUrl, setFullAuthUrl] = useState('');

    useEffect(() => {
        let userType = Cookies.get('milogin-usertype');

        if (userType === undefined) {
            console.warn('No User Type exists for MI Login! Defaulting to business user...');
            userType = 'Business';
        }

        api.OIDC_VALUE(userType, handleMiLoginSettings, handleErrors);
    }, [fullAuthUrl]);

    const handleMiLoginSettings = (settings) => {
        setFullAuthUrl(`${settings.autoProvisionUrl}`);
    }

    const handleErrors = (errors) => {
        console.error(errors);
    }

    if (fullAuthUrl === '') {
        return <Spinner className="page-loader"/>;
    }

    return (
        <div className="session-timeout">
            <h2>Session Timeout</h2>
            <span className="message">
                You have been logged out due to inactivity. Please <a href={fullAuthUrl}>login</a> again.
            </span>
        </div>
    )
}